import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3a35264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft overflow-hidden" }
const _hoisted_2 = { class: "p-4 border-b border-primary-100" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800" }, " Neighbor Posts ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New Post ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-wrap gap-2 mt-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "p-4 space-y-4"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-3 mb-2\" data-v-f3a35264><div class=\"w-8 h-8 bg-primary-100 rounded-full\" data-v-f3a35264></div><div class=\"h-4 bg-primary-100 rounded w-24\" data-v-f3a35264></div></div><div class=\"h-4 bg-primary-100 rounded w-full mb-1\" data-v-f3a35264></div><div class=\"h-4 bg-primary-50 rounded w-3/4\" data-v-f3a35264></div>", 3)
const _hoisted_14 = [
  _hoisted_11
]
const _hoisted_15 = {
  key: 1,
  class: "divide-y divide-primary-100 overflow-hidden"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "mb-2 px-2 py-1 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700 inline-flex items-center gap-1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1))
const _hoisted_19 = { class: "flex items-start gap-3" }
const _hoisted_20 = { class: "relative flex-shrink-0" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center text-primary-600 font-medium text-sm"
}
const _hoisted_23 = { class: "flex-1 min-w-0" }
const _hoisted_24 = { class: "flex items-center gap-2 mb-1 flex-wrap" }
const _hoisted_25 = { class: "text-sm font-medium text-primary-700" }
const _hoisted_26 = { class: "text-xs text-primary-400" }
const _hoisted_27 = { class: "font-medium text-primary-800 mb-1 line-clamp-1 break-words" }
const _hoisted_28 = { class: "text-sm text-primary-500 line-clamp-2 break-words" }
const _hoisted_29 = { class: "flex items-center justify-end mt-2" }
const _hoisted_30 = {
  key: 0,
  class: "inline-flex items-center gap-1 text-xs text-primary-400"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3.5 h-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1))
const _hoisted_32 = {
  key: 2,
  class: "p-8 text-center"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-12 h-12 mx-auto text-primary-300 mb-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500 mb-3" }, "No posts yet", -1))
const _hoisted_35 = {
  key: 3,
  class: "p-3 border-t border-primary-100 bg-primary-50"
}

import { ref, computed, h } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    posts: null,
    loading: { type: Boolean }
  },
  emits: ["create-post", "view-post", "view-all"],
  setup(__props: any) {

const props = __props as {
  posts: any[];
  loading: boolean;
}





const activeCategory = ref("all");

const categories = [
  { label: "All", value: "all" },
  { label: "Help", value: "looking_to_borrow" },
  { label: "For Sale", value: "for_sale" },
  { label: "Free", value: "free" },
  { label: "Services", value: "service_to_offer" },
  { label: "Questions", value: "question" },
];

const filteredPosts = computed(() => {
  if (activeCategory.value === "all") {
    return props.posts.slice(0, 5);
  }
  return props.posts.filter((p) => p.type === activeCategory.value).slice(0, 5);
});

const getCategoryLabel = (type: string) => {
  const labels: Record<string, string> = {
    looking_to_borrow: "Help Wanted",
    for_sale: "For Sale",
    free: "Free",
    service_to_offer: "Service",
    question: "Question",
    social: "Social",
    general: "General",
  };
  return labels[type] || "Post";
};

const getCategoryStyle = (type: string) => {
  const styles: Record<
    string,
    { bg: string; text: string; badge: string; icon: any }
  > = {
    looking_to_borrow: {
      bg: "bg-orange-100",
      text: "text-orange-600",
      badge: "bg-orange-100 text-orange-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z",
          }),
        ]
      ),
    },
    for_sale: {
      bg: "bg-green-100",
      text: "text-green-600",
      badge: "bg-green-100 text-green-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z",
          }),
        ]
      ),
    },
    free: {
      bg: "bg-emerald-100",
      text: "text-emerald-600",
      badge: "bg-emerald-100 text-emerald-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7",
          }),
        ]
      ),
    },
    service_to_offer: {
      bg: "bg-blue-100",
      text: "text-blue-600",
      badge: "bg-blue-100 text-blue-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
          }),
        ]
      ),
    },
    question: {
      bg: "bg-purple-100",
      text: "text-purple-600",
      badge: "bg-purple-100 text-purple-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
          }),
        ]
      ),
    },
    social: {
      bg: "bg-pink-100",
      text: "text-pink-600",
      badge: "bg-pink-100 text-pink-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
          }),
        ]
      ),
    },
    general: {
      bg: "bg-primary-100",
      text: "text-primary-600",
      badge: "bg-primary-100 text-primary-700",
      icon: h(
        "svg",
        {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
        },
        [
          h("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z",
          }),
        ]
      ),
    },
  };

  return styles[type] || styles.general;
};

const formatTime = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffHours / 24);

  if (diffHours < 1) return "Just now";
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  // If older than current year, show year
  if (date.getFullYear() < now.getFullYear()) {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

// Check if a post is stale (older than 6 months)
const isStalePost = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const sixMonthsAgo = new Date(now);
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  return date < sixMonthsAgo;
};

// Get the year from a date string
const getPostYear = (dateString: string) => {
  return new Date(dateString).getFullYear();
};

// Get initials from author object
const getInitials = (author: any) => {
  if (!author) return "?";
  const first = author.first_name?.[0] || "";
  const last = author.last_name?.[0] || "";
  return (first + last).toUpperCase() || "?";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('create-post'))),
          class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors"
        }, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (cat) => {
          return _createElementVNode("button", {
            key: cat.value,
            onClick: ($event: any) => (activeCategory.value = cat.value),
            class: _normalizeClass(["px-3 py-1 text-xs font-medium rounded-full transition-colors", 
            activeCategory.value === cat.value
              ? 'bg-primary-800 text-white'
              : 'bg-primary-100 text-primary-600 hover:bg-primary-200'
          ])
          }, _toDisplayString(cat.label), 11, _hoisted_9)
        }), 64))
      ])
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "animate-pulse"
            }, _hoisted_14)
          }), 64))
        ]))
      : (_unref(filteredPosts).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPosts), (post) => {
              return (_openBlock(), _createElementBlock("article", {
                key: post.id,
                class: _normalizeClass(["p-4 hover:bg-primary-50 transition-colors cursor-pointer", { 'opacity-60': isStalePost(post.created_on) }]),
                onClick: ($event: any) => (_ctx.$emit('view-post', post))
              }, [
                (isStalePost(post.created_on))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(" Older post from " + _toDisplayString(getPostYear(post.created_on)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (post.author?.profile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: post.author.profile,
                          alt: `${post.author.first_name}'s profile`,
                          class: "w-10 h-10 rounded-full object-cover"
                        }, null, 8, _hoisted_21))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(getInitials(post.author)), 1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center border-2 border-white", getCategoryStyle(post.type).bg])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getCategoryStyle(post.type).icon), {
                        class: _normalizeClass(["w-3 h-3", getCategoryStyle(post.type).text])
                      }, null, 8, ["class"]))
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(post.author?.first_name) + " " + _toDisplayString(post.author?.last_name?.[0]) + ". ", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2 py-0.5 text-xs font-medium rounded", getCategoryStyle(post.type).badge])
                      }, _toDisplayString(getCategoryLabel(post.type)), 3),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(formatTime(post.created_on)), 1)
                    ]),
                    _createElementVNode("h3", _hoisted_27, _toDisplayString(post.title), 1),
                    _createElementVNode("p", _hoisted_28, _toDisplayString(post.description), 1),
                    _createElementVNode("div", _hoisted_29, [
                      (post.comments?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                            _hoisted_31,
                            _createTextVNode(" " + _toDisplayString(post.comments.length), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 10, _hoisted_16))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _hoisted_33,
            _hoisted_34,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create-post'))),
              class: "text-accent-600 hover:text-accent-700 text-sm font-medium"
            }, " Be the first to share something ")
          ])),
    (_unref(filteredPosts).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('view-all'))),
            class: "w-full text-center text-sm text-primary-500 hover:text-primary-700 transition-colors"
          }, " View all posts → ")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})